import {useCallback, useState} from 'react';
import {useAxios} from './axios-hook';
import {useErrorHandler} from './error-hook';
import {enqueueSnackbar} from "notistack";
import {useDispatch} from "react-redux";

export const useApi = (options = {}) => {
    const [data, setData] = useState(options.initialValue);
    const [isLoading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const {handleError} = useErrorHandler();
    const {axios, initialized} = useAxios();

    const request = async (spec) => {
        if (!initialized) {
            return;
        }

        const fetchData = async () => {
            const {url, method, data, store, loader, notification} = spec
            setLoading(true);
            !!loader && dispatch(loader(true));
            try {
                const response = await axios({url, method, data, ...options});
                const responseData = mapResponseToData(response);
                setData(responseData);
                if (!!store) {
                    dispatch(store(responseData))
                }
                if (!!notification?.message) {
                    enqueueSnackbar(notification.message)
                } else if (!!notification?.api) {
                }
            } catch (err) {
                console.debug(err)
                const [message, redirect] = handleError(err);
                enqueueSnackbar(message)
            } finally {
                setLoading(false);
                !!loader && dispatch(loader(false));
            }
        };

        await fetchData();
    };
    const api = useCallback(request, [initialized]);

    return {isLoading, data, api, initialized};
};


export const mapResponseToData = (response) => {
    const {data} = response;
    return data;
};
